import { array, object } from "yup";

export default object().shape({
  ages: array().required("Please select target ages"),
  genders: array().required("Please select target genders"),
  locations: array().required("Please select target locations"),
  tags: array().required("Please select tags")
});
